import { gql } from "@apollo/client";

export const checkinOverviewDownload = gql`
  query checkinOverviewDownload($checkinId: ID, $downloadType: FileType, $sequenceNo: Int) {
    checkinOverviewDownload(
      checkinId: $checkinId
      downloadType: $downloadType
      sequenceNo: $sequenceNo
    ) {
      type
      file
      fileName
    }
  }
`;
